import {PERMS} from '../../../config/permissions.js'
import routeHelper from '../../../utils/routeHelper'

export const menuMixin = {
  watch: {
    '$route': 'closeMenu'
  },
  computed: {
    isAuth(){
      let userData = this.$store.getters.userData;
      if (!userData) {
        return false
      }
      return userData.access_token;

    },
    hasMenuItems() {
      return this.acceptedMenuItems && this.acceptedMenuItems.length > 0
    },
    acceptedMenuItems() {
      let userData = this.$store.getters.userData;
      if (!userData) {
        return []
      }
      if (!userData.access_token) {
        return []
      }
      // get flat route tree
      // for check meta information
      let routes = routeHelper.getFlatTree(this.$router);
      let menuItems = this.menuItems;
      let checkedRoutes = [];
      let menuRouteObject = {};
      let child = {};
      menuItems.forEach(v => {
        menuRouteObject = Object.assign(v, routes[v.name] || {});
        // console.log('menuRouteObject', menuRouteObject)
        // check main group perms
        if (this.userCanView(menuRouteObject)) {
          if (menuRouteObject.meta) {
            menuRouteObject.title = menuRouteObject.title || menuRouteObject.meta.title;
            menuRouteObject.number = menuRouteObject.number || menuRouteObject.meta.number
          }
          if (menuRouteObject.childs) {
            menuRouteObject.childs.forEach((item, i) => {
              let subRoute = Object.assign(item, routes[item.name] || {});
              if (subRoute.meta) {
                subRoute.title = subRoute.title || subRoute.meta.title;
                subRoute.number = subRoute.number || subRoute.meta.number
              }
              menuRouteObject[i] = subRoute
            })
          }
          checkedRoutes.push(menuRouteObject)
        } else {
          // check sub group
          let openedChilds = [];
          let currentRoute = Object.assign(v, routes[v.name] || {});
          if (v.childs) {
            v.childs.forEach(item => {
              child = Object.assign(item, routes[item.name] || {});
              // console.log('child', child)
              if (this.userCanView(child)) {
                if (child.meta) {
                  child.title = child.title || child.meta.title;
                  child.number = child.number || child.meta.number
                }
                openedChilds.push(child)
              }
            })
          }
          if (openedChilds.length > 0) {
            currentRoute.childs = openedChilds;
            // set first subsection url as root section url
            // TODO: check that
            currentRoute.href = openedChilds[0].href;
            currentRoute.name = openedChilds[0].name;
            checkedRoutes.push(currentRoute)
          } else {
            currentRoute.childs = []
          }
        }
      });

      return checkedRoutes
    },
    isOpened() {
      return this.$store.state.menustate
    }
  },
  methods: {
    userCanView (route) {
      return this.$store.getters.userCan(PERMS.VIEW, {route: route})
    },
    outerClick () {
      this.$store.commit('closeMenu')
    },
    closeMenu () {
      this.$store.commit('closeMenu')
    },
    menuList (endpoint) {
      return this.$store.dispatch('updateUrlEndpoint', {
        endpoint
      })
    }
  }
};
